import { observable } from "mobx";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";
import { Type } from "class-transformer";
import CurrencyCode from "./currencyCode";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DomesticTransferPaymentResponse {
  @observable
  @Type(() => DomesticBankAccountResponse)
  bankAccount!: DomesticBankAccountResponse;

  @observable
  qrCode!: string;

  @observable
  amount!: number;

  @observable
  messageForRecipient!: string;

  @observable
  currencyCode!: CurrencyCode;
}
